import React from 'react';
const Button = React.lazy(() => import('@material-ui/core/Button'));
const Grid = React.lazy(() => import('@material-ui/core/Grid'));
import {StandartInput} from '@components/form/StandartInput';
const RemoteAutocompleteSelect = React.lazy(() => import('@components/form/RemoteAutocompleteSelect'));
const RemoteAutocompleteWithSearch = React.lazy(() => import('@components/form/RemoteAutocompleteWithSearch'));
const merge = require('deepmerge');
const FormLabel = React.lazy(() => import('@material-ui/core/FormLabel'));
const InputAdornment = React.lazy(() => import('@material-ui/core/InputAdornment'));
import {ProductVariationContainer} from '@components/product/modals/new-product/product-variation.container';
import { ProductPricesContainer } from './product-prices.container';
import {PricesTableComponent} from "@components/product/modals/new-product/components/prices-table.component";
import {NewCategoryContainer} from '@components/categories/modals/new-category/new-category.container';
import {SimpleDialog} from "@components/form/SimpleDialog";
const ResponsiveComponent = React.lazy(() => import('@components/form/ResponsiveComponent'));
import AddCircleRoundedIcon from '@material-ui/icons/AddCircleRounded';
import Typography from "@material-ui/core/Typography";
import {MaterialTableComponent} from "@components/form/MaterialTableComponent";
import {LabelButton} from "@components/common/buttons/LabelButton";
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';
import {TooltipButton} from "@components/common/buttons/TooltipButton";
import clsx from "clsx";

export class NewProductComponent extends React.Component {
    initState = {
        form: {
            title: "",
            title_short: "",
            category_id: "",
            description: "",
            model: "",
            image: "",
            settings: {
                weight: "0.1",
                dimension_width: "",
                dimension_height: "",
                dimension_deep: "",
            },
            main: {
                sku: "",
                barcode: "",
                price: "",
                price_in: "",
                prices: [],
                status: true,
                main_supplier_id: "",
            },
            variations: [],
            status: 1,
        },
        category: null,
        refreshCategories: 0,
        searchString: undefined,
        file: undefined,
        errors: {}
    };
    state = {
        open: false,
        ...this.initState
    }

    async componentDidUpdate(prevState, prevProps) {
        if (this.props.productId && this.state.open && this.state.open != prevProps.open) {
            const data = await this.props.getProductDetails(this.props.productId);
            this.setState({form: merge(this.state.form, {...data.data, image: data.data.image[0]})});
        } else if (this.state.open != prevProps.open) {
            this.setState(this.initState)
        }
    }

    updateProductGroup = async () => {
        let response = await this.props.updateProductGroup(
            this.props.productId,
            this.state.form,
        );
        if (response.errors && Object.keys(response.errors).length) {
            this.setState({errors: response.errors});
        } else {
            if (response.data && response.data.id) { //success
                this.setState({open: false});
                if (this.props.tableRef)
                    this.props.tableRef.current.onQueryChange();
                else this.props.onSubmitRedirect(response.data);
            }
        }
    };

    handleVariationSubmit = (data, variationId = undefined) => {
        let {form: {variations}} = this.state;

        if (data.id) { //already existed
            variations = variations.map((row) => {
                if (row.id === data.id) {
                    row = data;
                }
                return row;
            })
        } else if (!variationId && data.characteristic_id) { // created but not yet saved
            let found = false;
            variations = variations.map((row) => {
                if (row.characteristic_id === data.characteristic_id) {
                    row = data;
                    found = true;
                }
                return row;
            });
            if (!found) {
                variations.push(data);
            }
        } else {
            variations.push(data);
        }
        this.setState({
            form: {...this.state.form, variations: [...variations]}
        });
    };

    handlePriceGroupSubmit = (data, priceGroupId = undefined) => {
        let {form: {main: {prices}}} = this.state;
        if (typeof data.group == "undefined") {
            //тут нужно прописать группу цен полностью, возможно из props.AllPrices
            data.group = {
                is_default: false
            }
        }

        if (data.id) {
            prices = prices.map(group => {
                if (group.id === data.id)
                    group = data;
                return group;
            })
        } else if (!priceGroupId && data.group_id) {
            let found = false;
            prices = prices.map(group => {
                if (group.group_id === data.group_id) {
                    group = data;
                    found = true;
                }
                return group;
            });
            if (!found) {
                prices.push(data);
            }
        } else prices.push(data);
        this.setState({
            form: {...this.state.form, main: {...this.state.form.main, prices: [...prices]}}
        });
    }

    getPhoto = (e) => {
        e.preventDefault();

        let reader = new FileReader();
        let file = e.target.files[0];

        reader.onloadend = () => {
            this.setState(
                merge(this.state, {form: {image: reader.result }})
            , () => this.setState({file: file}));
        };

        reader.readAsDataURL(file);
    };

    categoryCreated = (category) => {
        this.setState({
            ...this.state,
            category: {value: category.id, label: category.name},
            refreshCategories: category.id,
            form: {...this.state.form, category_id: category.id},
        })
    };

    input = ({name, label, ...other}) => <StandartInput
        name={name}
        value={this.state.form[name]}
        errors={this.state.errors}
        className={this.props.classes.input}
        size={'small'}
        margin={'normal'}
        variant={'outlined'}
        label={label}
        fullWidth
        onChange={({target: {value}}) => this.setState(merge(this.state, {form: {[name]: value}}))}
        {...other}
    />

    settingsInput = ({name,label, adornment }) => <StandartInput
        name={name}
        value={this.state.form.settings[name]}
        errors={this.state.errors}
        errorSubKey={'settings'}
        className={this.props.classes.input}
        label={label}
        onChange={({target: {value}}) => this.setState(merge(this.state, {form: {settings: {[name]: value}}}))}
        InputProps={{
            startAdornment: <InputAdornment position="start">{adornment}</InputAdornment>,
        }}
        type={'number'}
        size={'small'}
        margin={'normal'}
        variant={'outlined'}
        fullWidth
    />

    mainInput = ({name, label, ...other}) => <StandartInput
        name={name}
        value={this.state.form.main[name]}
        errors={this.state.errors}
        errorSubKey={'main'}
        className={this.props.classes.input}
        label={label}
        onChange={({target: {value}}) => this.setState(merge(this.state, {form: {main: {[name]: value}}}))}
        size={'small'}
        margin={'normal'}
        variant={'outlined'}
        fullWidth
        {...other}
    />

    render() {
        let { classes } = this.props;

        return (
            <SimpleDialog
                fullWidth={true}
                maxWidth={'md'}
                open={this.state.open}
                onClose={(e) => this.setState({open: false})}
                title={ this.props.productId
                    ? <ResponsiveComponent xs='Редактирование товара' sm='Редактирование существующей карточки товара'/>
                    : <ResponsiveComponent xs='Добавление товара' sm='Добавление новой карточки товара' />}
                icon={ this.props.customOpenButton
                    ? <span style={{cursor: 'pointer'}} onClick={e => this.setState({open: true})}>{this.props.customOpenButton}</span>
                    : this.props.productId
                        ? (<TooltipButton title="Редактировать"
                            icon={<EditOutlinedIcon color={'primary'} style={{marginLeft: 'auto'}} />}
                            onClick={(e) => this.setState({open: true})}
                        />)
                        : (<LabelButton
                            title={'Добавить товар'}
                            icon={<AddCircleRoundedIcon color={'primary'}/>}
                            onClick={(e) => this.setState({open: true})}
                            disableMargin
                        />)}
                actions={[
                    (<Button
                        onClick={(e) => this.updateProductGroup()}
                        color="primary" variant="contained"
                    >
                        Сохранить
                    </Button>),
                ]}
            >
                <Grid container spacing={3} className={classes.gridContainer}>
                    <Grid item xs={12} md={6}>
                        <FormLabel className={classes.formLabel} component="legend">Основные признаки</FormLabel>
                        {this.input({name: 'title', label: "Название"})}
                        {this.input({name: 'title_short', label: "Название для сайта"})}

                        <div className={classes.categoryInput}>
                            <RemoteAutocompleteWithSearch
                                name={'category_id'}
                                url={'/api/v1/categories/autocomplete?' + this.state.refreshCategories}
                                SearchString={this.state.searchString}
                                value={this.state.form.category_id}
                                label="Категория товара"
                                onChange={(e, {value}) => this.setState(merge(this.state, {form: {category_id: value}}))}
                                errors={this.state.errors}
                                className={classes.input}
                                size={'small'}
                                margin={'normal'}
                                variant={'outlined'}
                                objectValue={this.state.category}
                            />
                            <NewCategoryContainer
                                customOpenButton={<AddCircleRoundedIcon className={classes.input_icon} color={'primary'}/>}
                                onSubmitRedirect={this.categoryCreated}
                            />
                        </div>

                        {this.input({name: 'model', label: "Модель", popover: 'Подсказка для поля модель'})}
                        {this.input({name: 'description', label: "Описание", multiline: true, rows: 3, rowsMax: 5, })}
                    </Grid>

                    <Grid item xs={12} md={6}>
                        <FormLabel className={clsx([classes.formLabel, classes.formLabel_marginTop_downSm])} component="legend">Габариты</FormLabel>
                        <Grid container spacing={3} className={classes.gridSubContainer}>
                            <Grid item xs={12} md={5}>
                                <Grid container className={classes.settingsGrid}>
                                    <Grid item xs={6} md={12}>
                                        {this.settingsInput({name: 'weight', label: "Вес", adornment: 'кг' })}
                                    </Grid>
                                    <Grid item xs={6} md={12}>
                                        {this.settingsInput({name: 'dimension_width', label: "Ширина", adornment: 'см' })}
                                    </Grid>
                                    <Grid item xs={6} md={12}>
                                        {this.settingsInput({name: 'dimension_height', label: "Высота", adornment: 'см' })}
                                    </Grid>
                                    <Grid item xs={6} md={12}>
                                        {this.settingsInput({name: 'dimension_deep', label: "Глубина", adornment: 'см' })}
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid item xs={12} md={7}>
                                <input
                                    accept="image/*"
                                    // className={classes.input}
                                    style={{ display: 'none' }}
                                    id="raised-button-file"
                                    // multiple
                                    type="file"
                                    onChange={this.getPhoto}
                                    name={'avatar'}
                                />
                                <label htmlFor="raised-button-file">
                                    <div
                                        className={classes.image}
                                        style={{backgroundImage: 'url(' + this.state.form.image + ')'}}
                                    >{this.state.form.image ? '' : 'Добавить фото'}</div>
                                </label>
                            </Grid>
                        </Grid>

                        {this.state.form.variations.length === 0
                            ? <>
                                <FormLabel className={clsx([classes.formLabel, classes.formLabel_marginTop])} component="legend">Товар без вариаций</FormLabel>
                                <Grid container spacing={3} className={classes.gridSubContainer}>
                                    <Grid item xs={12} md={6}>
                                        {this.mainInput({name: 'sku', label: 'SKU'})}
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        {this.mainInput({name: 'barcode', label: 'Штрих-код'})}
                                    </Grid>
                                </Grid>
                                <Grid container spacing={3} className={classes.gridSubContainer}>
                                    <Grid item xs={12} md={6}>
                                        {this.mainInput({
                                            name: 'price',
                                            label: 'Розничная цена',
                                            type: 'number',
                                            InputProps: {startAdornment: <InputAdornment position="start">грн</InputAdornment>},
                                        })}
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        {this.mainInput({
                                            name: 'price_in',
                                            label: 'Цена прихода',
                                            type: 'number',
                                            InputProps: {startAdornment: <InputAdornment position="start">грн</InputAdornment>},
                                        })}
                                    </Grid>
                                </Grid>

                                {(this.state.form.main.prices.length > 0) && (this.state.form.main.prices.filter((row) => {return !row.group?.is_default}).length > 0)
                                    ? <>
                                        <FormLabel className={clsx([classes.formLabel, classes.formLabel_marginTop])} component="legend">Дополнительные цены</FormLabel>
                                        <div className={classes.tableWrapper}>
                                            <PricesTableComponent
                                                prices={this.state.form.main.prices}
                                                groups={this.props.price_groups}
                                                onSubmit={this.handlePriceGroupSubmit}
                                            />
                                        </div>
                                    </>
                                    : null
                                }

                                <ProductPricesContainer
                                    onSubmit={this.handlePriceGroupSubmit}
                                    price_groups={this.props.price_groups}
                                />

                                <RemoteAutocompleteSelect
                                    name={'main_supplier_id'}
                                    url={'/api/v1/suppliers/autocomplete'}
                                    value={this.state.form.main.main_supplier_id}
                                    errors={this.state.errors}
                                    label="Основной поставщик"
                                    onChange={(e, {value}) => this.setState(merge(this.state, {form: {main: {main_supplier_id: value}}}))}
                                    disableClearable={true}
                                    errorSubKey={'main'}
                                    size={'small'}
                                    margin={'normal'}
                                    variant={'outlined'}
                                    fullWidth
                                />
                                {!this.props.disableVariationsCreation && (!this.props.productId || this.state.form.variations.length !== 0) ? <ProductVariationContainer
                                    onSubmit={this.handleVariationSubmit}
                                    price_groups={this.props.price_groups}
                                /> : null}
                            </>
                            : <>
                                <FormLabel className={clsx([classes.formLabel, classes.formLabel_marginTop])} component="legend">Вариации товара</FormLabel>
                                <div className={classes.tableWrapper}>
                                    <MaterialTableComponent
                                        data={this.state.form.variations}
                                        columns={[
                                            {
                                                title: 'SKU',
                                                field: 'sku',
                                                hideMobileTitle: true,
                                                render: row => row.sku + (!!row?.characteristic?.name ? ' (' + row.characteristic.name + ')' : ''),
                                                mobileRender: (row, rowIndex) => <Grid container style={{padding: '20px 10px 10px'}}>
                                                    <Grid item xs={6}>
                                                        <Typography variant={'body2'}>SKU</Typography>
                                                    </Grid>
                                                    <Grid item xs={6}>
                                                        <Typography variant={'body2'}>{row.sku + (!!row?.characteristic?.name ? ' (' + row.characteristic.name + ')' : '')}</Typography> && {console.log(row)}
                                                    </Grid>
                                                </Grid>
                                            },
                                            {
                                                title: 'Штрих-код',
                                                field: 'barcode',
                                                hideMobileTitle: true,
                                                mobileCellProps: {style: {width: '100%'}},
                                                mobileRender: (row, rowIndex) => <Grid container style={{padding: '10px'}}>
                                                    <Grid item xs={6}>
                                                        <Typography variant={'body2'}>Штрих-код</Typography>
                                                    </Grid>
                                                    <Grid item xs={6}>
                                                        <Typography variant={'body2'}>{row.barcode}</Typography>
                                                    </Grid>
                                                </Grid>
                                            },
                                            {
                                                title: 'Цена',
                                                field: 'data.message',
                                                hideMobileTitle: true,
                                                render: row => parseFloat(row.price).toFixed(2),
                                                mobileRender: (row, rowIndex) => <Grid container style={{padding: '10px 10px 20px'}}>
                                                    <Grid item xs={6}>
                                                        <Typography variant={'body2'}>Цена</Typography>
                                                    </Grid>
                                                    <Grid item xs={6}>
                                                        <Typography variant={'body2'}>{parseFloat(row.price).toFixed(2)}</Typography>
                                                    </Grid>
                                                </Grid>
                                            },
                                        ]}
                                        actions={[
                                            {
                                                icon: (row, index) => <ProductVariationContainer
                                                    onSubmit={this.handleVariationSubmit}
                                                    data={row}
                                                    variationId={row.id}
                                                    price_groups={this.props.price_groups}
                                                >
                                                    <EditOutlinedIcon color={'primary'}/>
                                                </ProductVariationContainer>,
                                                onClick: () => true,
                                            },
                                        ]}
                                    />
                                </div>
                                <ProductVariationContainer
                                    price_groups={this.props.price_groups}
                                    onSubmit={this.handleVariationSubmit}
                                />
                            </>
                        }
                    </Grid>
                </Grid>
            </SimpleDialog>
        );
    }
}
